import { withStyles } from "@material-ui/core/styles";
import MuiAccordion from "@material-ui/core/Accordion";

export const CustomAccordion = withStyles({
  root: {
    backgroundColor: "transparent",
    borderBottom: 0,
    "&:before": {
      display: "none",
    },
    "&$expanded": {
      margin: "auto",
      minHeight: "48px",
    },
  },
  expanded: {},
})(MuiAccordion);
